<app-status [status]="importResponse.status"></app-status>
<app-log-lines [logLines]="importResponse.logLines"></app-log-lines>